module.exports = __webpack_public_path__ + "static/media/recent-02.4fc0284c.jpg";